import { render, staticRenderFns } from "./best-ranking-table.component.vue?vue&type=template&id=aa7ee10c&scoped=true"
import script from "./best-ranking-table.component.vue?vue&type=script&lang=js"
export * from "./best-ranking-table.component.vue?vue&type=script&lang=js"
import style0 from "./best-ranking-table.component.vue?vue&type=style&index=0&id=aa7ee10c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7ee10c",
  null
  
)

export default component.exports